import React from "react";
import { Link } from "react-router-dom";
import medeenuud from "../../api/medee-medeelel";

const MedeeSidebar = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };
  // const SubmitHandler = (e) => {
  //   e.preventDefault();
  // };
  const today = new Date();
  const month = today.getMonth() + 1;
  const year = today.getFullYear();
  const date = today.getDate();
  return (
    <div className="col-lg-4 mb-30">
      <div className="sidebarLayout">
        <div className="innerWrapperSidebar mb-30">
          <div className="sidebarWidget">
            <div className="sidebarTitle">
              <h5 className="sidebarTitle__heading text-uppercase mb-30">
                Мэдээний ангилал
              </h5>
            </div>
            {/* <div className="sidebarCategories">
              <ul>
                <li>
                  <Link to="">
                    <span>Бүх</span>
                    <span>{medeenuud.length}</span>
                  </Link>
                </li>
                <li>
                  <Link to="">
                    <span>Анхааруулга</span>
                    <span>
                      {
                        medeenuud.filter(
                          (item) => item.category === "анхааруулга"
                        ).length
                      }
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="">
                    <span>Боловсрол</span>
                    <span>
                      {
                        medeenuud.filter((item) => item.category === "bolov")
                          .length
                      }
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="">
                    <span>Эрүүл мэнд</span>
                    <span>
                      {
                        medeenuud.filter((item) => item.category === "medic")
                          .length
                      }
                    </span>
                  </Link>
                </li>
              </ul>
            </div> */}
            <div className="sidebarCategories">
              <ul>
                {/* "Бүх" нийт мэдээний тоо */}
                <li>
                  <Link to="">
                    <span>Бүх мэдээ</span>
                    <span>{medeenuud.length}</span>
                  </Link>
                </li>

                {/* Категори тус бүрээр динамик li гаргах */}
                {Array.from(
                  new Set(medeenuud.map((item) => item.category))
                ).map((category) => (
                  <li key={category}>
                    <Link to="">
                      <span>{category}</span>
                      <span>
                        {
                          medeenuud.filter((item) => item.category === category)
                            .length
                        }
                      </span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="innerWrapperSidebar mb-30">
          <div className="sidebarWidget">
            <div className="sidebarTitle">
              <h5 className="sidebarTitle__heading text-uppercase mb-30">
                Сүүлийн мэдээ
              </h5>
            </div>
            <div className="sidebarBlogs">
              <ul>
                {medeenuud
                  .slice(-2)
                  .map((blog, Bitem) => (
                    <li key={Bitem}>
                      <div className="blogBlockSmall">
                        <figure className="blogBlockSmall__thumb">
                          <Link
                            onClick={ClickHandler}
                            to={`/medee-medeelel/${blog.slug}`}
                            className="blogBlockSmall__thumb__link"
                          >
                            <img src={blog.screens} alt="mcc" />
                          </Link>
                        </figure>
                        <figure className="blogBlockSmall__content">
                          <span className="blogBlockSmall__meta">
                            {blog.create_at}
                          </span>
                          <h3 className="blogBlockSmall__heading">
                            <Link
                              onClick={ClickHandler}
                              to={`/medee-medeelel/${blog.slug}`}
                            >
                              {blog.title}
                            </Link>
                          </h3>
                        </figure>
                      </div>
                    </li>
                  ))
                  .reverse()}
              </ul>
            </div>
          </div>
        </div>

        <div className="innerWrapperSidebar mb-30">
          <div className="sidebarWidget">
            <div className="sidebarTitle">
              <h5 className="sidebarTitle__heading text-uppercase mb-30">
                Холбоо барих
              </h5>
            </div>
            <div className="sidebarContact">
              <ul>
                <li>
                  <span>Хаяг: </span>
                  БГД, 9-р хороо, 3-р хороолол, Ард Аюушын өргөн чөлөө, 75 тоот
                </li>
                <li>
                  <span>И-Мэйл: </span>
                  mongol.suvd.church@gmail.com
                </li>
                <li>
                  <span>Утас: </span>
                  +976 99724328, 90004328
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MedeeSidebar;
